var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8ExpandArrow4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16.766,
    viewBox: "0 0 10 16.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.752 16.09 9.064 10.4a1.579 1.579 0 0 0-2.233 0 1.579 1.579 0 0 0 0 2.233L13.7 19.5a1.487 1.487 0 0 0 2.1 0l6.868-6.868a1.579 1.579 0 0 0 0-2.233 1.579 1.579 0 0 0-2.233 0z",
    transform: "rotate(90 13.155 6.786)",
    style: {
      fill: "#002983"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ExpandArrow4);
export default __webpack_public_path__ + "static/media/icons8-expand-arrow_4.4898b2b616ac63b61c415041a456a305.svg";
export { ForwardRef as ReactComponent };